import { render, staticRenderFns } from "./ObjectifsIndicateur.vue?vue&type=template&id=4627acde"
import script from "./ObjectifsIndicateur.vue?vue&type=script&lang=js"
export * from "./ObjectifsIndicateur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports